<template>
  <beer itemId="2000000004" itemName="ice-ice-hazy" title="Ice Ice Hazy, 15 °P, New England IPA">
    <p
      style="
          margin: auto;
          text-align: justify;
          max-width: 40rem;
          width: 100%;
          margin-top: 4rem;
        "
    >
      Náš zástupce stále populárnějších piv stylu New England IPA. Díky přidání ovesných vloček je toto pivo typicky
      zakalené, použité chmely se zase postaraly o příjemnou dávku aromatu tropického ovoce. Tak si pozvěte trochu
      exotiky domů.
    </p>

    <table
      class="tg"
      style="
          margin: auto;
          text-align: left;
          max-width: 40rem;
          width: 100%;
          margin-top: 4rem;
        "
    >
      <tbody>
        <tr>
          <td class="bold">Pivní styl</td>
          <td class="right">New England IPA</td>
        </tr>
        <tr>
          <td>Stupňovitost</td>
          <td class="right">15 °P</td>
        </tr>
        <tr>
          <td>Alkohol</td>
          <td class="right">6,3 %</td>
        </tr>
        <tr>
          <td>Barva</td>
          <td class="right">5 SRM</td>
        </tr>
        <tr>
          <td>Hořkost</td>
          <td class="right">46 IBU</td>
        </tr>
        <tr>
          <td>Slady</td>
          <td class="right">pale ale, karamelový, ovesné vločky</td>
        </tr>
        <tr>
          <td>Chmely</td>
          <td class="right">Azacca, Mosaic, Simcoe</td>
        </tr>
      </tbody>
    </table>
  </beer>
</template>

<script>
import Beer from "../Beer";
export default {
  name: "IceIceHazy",
  components: { Beer },
};
</script>
